import { Bar, BarChart, XAxis } from "recharts";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { useWeeklyStats } from "@/hooks/useStats";
import { Skeleton } from "@/components/ui/skeleton";

interface WeeklyChartProps {
  companyId?: string;
}

export const WeeklyChart = ({ companyId }: WeeklyChartProps) => {
  const { data, isLoading, error } = useWeeklyStats(companyId);

  if (isLoading) {
    return (
      <div className="h-64 flex items-center justify-center">
        <Skeleton className="h-full w-full" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-64 flex items-center justify-center">
        <p className="text-muted-foreground">
          Erreur lors du chargement des données
        </p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center">
        <p className="text-muted-foreground">Aucune donnée disponible</p>
      </div>
    );
  }

  // Configuration du graphique
  const chartConfig = {
    count: {
      label: "Sessions",
      color: "#051941", // Couleur primary
    },
  };

  return (
    <div className="w-full h-64 sm:h-80">
      <ChartContainer config={chartConfig} className="h-full w-full [&]:!aspect-auto">
        <BarChart data={data}>
          <XAxis
            dataKey="day"
            tickLine={false}
            tickMargin={10}
            axisLine={false}
            tickFormatter={(value) => value}
          />
          <ChartTooltip content={<ChartTooltipContent />} />
          <Bar dataKey="count" fill="var(--color-count)" radius={4} />
        </BarChart>
      </ChartContainer>
    </div>
  );
};
